<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">User Setup</div>
        <div>
          <bread-crumb :bread-crumbs="['User Summary', 'User Setup']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text class="pt-4 ma-0">
        <v-form ref="form" v-model="valid">
          <v-card class="pb-3">
            <v-sheet
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="2"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-icon small class="me-1">mdi-office-building-outline</v-icon
                >USER INFORMATION
              </p>
            </v-sheet>
            <v-row class="ms-1 me-1 mt-1" justify="center">
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="required labelFontsize my-0"> Tittle </label>
                <v-autocomplete
                  class="rounded"
                  dense
                  outlined
                  placeholder="Tittle"
                  v-model="userDetails.title"
                  :items="userTitle"
                  :rules="salutation"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="required labelFontsize my-0">Gender</label>
                <v-autocomplete
                  class="rounded"
                  dense
                  outlined
                  placeholder="Gender"
                  v-model="userDetails.gender"
                  :items="['Male', 'Female']"
                  :rules="genderValidations"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="required labelFontsize my-0">Agent/Branch</label>
                <v-autocomplete
                  class="rounded"
                  dense
                  outlined
                  placeholder="Agent type"
                  v-model="userDetails.agent_type"
                  :items="agentType"
                  :rules="agent_type"
                  item-text="text"
                  item-value="value"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row class="ms-1 me-1 mt-1" justify="center">
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="required labelFontsize my-0"> First Name </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder="First Name"
                  v-model="userDetails.first_name"
                  :rules="firstnameValidations"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0"> Middle Name </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder="Middle Name"
                  v-model="userDetails.middle_name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="required labelFontsize my-0"> Last Name </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder="Last Name"
                  v-model="userDetails.last_name"
                  :rules="lastnameValidations"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ms-1 me-1 mt-1">
              <!-- <v-col cols="12" md="4" lg="4" xs="12">
                <label class="required labelFontsize my-0">
                  User Name/ID
                </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder="User Name"
                  v-model="userDetails.user_name"
                  :rules="userId"
                ></v-text-field>
              </v-col> -->
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="required labelFontsize my-0"> Login type </label>
                <v-autocomplete
                  class="rounded"
                  dense
                  outlined
                  placeholder="Login type"
                  :disabled="true"
                  v-model="userDetails.login_type"
                  :items="['Single', 'Multiple']"
                  :rules="login_type"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0">
                  Session Time-out(in Minites)
                </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder=""
                  type="number"
                  hide-spin-buttons
                  @keydown="nodotNumber"
                  v-model="userDetails.session_timeout"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="required labelFontsize my-0"> Country </label>
                <v-autocomplete
                  class="rounded"
                  dense
                  outlined
                  placeholder="Country"
                  v-model="userDetails.country"
                  :items="countryOptions"
                  :rules="country_Rules"
                  item-text="text"
                  item-value="value"
                ></v-autocomplete>
              </v-col>
              <!-- <v-col cols="12" md="4" lg="4" xs="12">
                <label class="required labelFontsize my-0">
                  Pwd Change Days
                </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder=""
                  type="number"
                  hide-spin-buttons
                  @keydown="nodotNumber"
                  v-model="userDetails.password_change_days"
                  :rules="pwdChangeDays"
                ></v-text-field>
              </v-col> -->
            </v-row>
            <v-row class="ms-1 me-1 mt-1">
              <!-- <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0">
                  Pwd Change Warning Days
                </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder=""
                  type="number"
                  hide-spin-buttons
                  @keydown="nodotNumber"
                  v-model="userDetails.password_change_warning_days"
                ></v-text-field>
              </v-col> -->

              <!-- <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0"> Max Report View Days </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder=""
                  type="number"
                  hide-spin-buttons
                  @keydown="nodotNumber"
                  v-model="userDetails.max_report_view_days"
                ></v-text-field>
              </v-col> -->
            </v-row>
            <!-- <v-row class="ms-1 me-1 mt-1" justify="center">
              <v-col cols="12" md="4" lg="6" xs="12">
                <label class="required labelFontsize my-0">
                  Send Transaction From
                </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder=""
                  :disabled="true"
                  v-model="userDetails.send_transaction_from"
                  type="time"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="6" xs="12">
                <label class="required labelFontsize my-0">
                  Send Transaction To
                </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder=""
                  type="time"
                  v-model="userDetails.send_transaction_to"
                  :disabled="true"
                ></v-text-field>
              </v-col>
            </v-row> -->
            <!-- <v-row class="ms-1 me-1 mt-1" justify="center">
              <v-col cols="12" md="4" lg="6" xs="12">
                <label class="required labelFontsize my-0">
                  Pay Transaction From
                </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder=""
                  type="time"
                  v-model="userDetails.pay_transaction_from"
                  :disabled="true"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="6" xs="12">
                <label class="required labelFontsize my-0">
                  Pay Transaction To
                </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder=""
                  type="time"
                  v-model="userDetails.pay_transaction_to"
                  :disabled="true"
                ></v-text-field>
              </v-col>
            </v-row> -->
            <v-row class="ms-1 me-1 mt-1">
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="required labelFontsize my-0"> Address </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder="Address"
                  v-model="userDetails.address"
                  :rules="addressValidations"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="required labelFontsize my-0"> Time zone </label>
                <v-autocomplete
                  class="rounded"
                  dense
                  outlined
                  placeholder="Time zone"
                  v-model="userDetails.timezone"
                  :rules="time_zone"
                  :items="timeZones"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize required my-0"> Email</label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder="Email"
                  v-model="userDetails.email"
                  :rules="optionalEmailValidations"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ms-1 me-1 mt-1">
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="required labelFontsize my-0"> Mobile </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder="Mobile"
                  type="number"
                  hide-spin-buttons
                  @keydown="nodotNumber"
                  v-model="userDetails.mobile"
                  :rules="mobilenumberValidations"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0">Alternate Mobile </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder="Phone"
                  v-model="userDetails.alt_mobile"
                  type="number"
                  hide-spin-buttons
                  @keydown="nodotNumber"
                  :rules="alt_MobileValidations"
                  @input="validateAltNumber(userDetails.alt_mobile)"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-col cols="4" class="d-flex justify-space-between">
              <v-checkbox label="Allow Integration" v-model="IsIntegrated">
              </v-checkbox>
              <v-btn
                @click="generateInetgrationData()"
                v-if="IsIntegrated"
                class="mt-6"
                flat
                elevation="0"
                color="primary"
                dense
              >
                Generate
              </v-btn>
            </v-col>
            <v-divider
              class="p-0 m-0 primary--text"
              v-if="IsIntegrated"
            ></v-divider>
            <v-row class="ms-1 me-1 mt-1" v-if="IsIntegrated">
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0"> API User ID </label>
                <v-text-field
                  v-model="ApiUser.api_user_id"
                  class="rounded"
                  dense
                  outlined
                  placeholder="API User ID"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0">
                  API Access Code (PIN)
                </label>
                <v-text-field
                  v-model="ApiUser.api_access_code"
                  class="rounded"
                  dense
                  outlined
                  placeholder="API Access Code"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0">
                  API Authentication Code
                </label>
                <v-text-field
                  v-model="ApiUser.api_authentication_code"
                  class="rounded"
                  dense
                  outlined
                  placeholder="API Authentication Code"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0"> API Receiving Code </label>
                <v-text-field
                  v-model="ApiUser.api_receiving_code"
                  class="rounded"
                  dense
                  outlined
                  placeholder="API Receiving Code"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0"> Call Back URL </label>
                <v-text-field
                  v-model="ApiUser.callback_url"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Call Back"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
      </v-card-text>
      <v-divider class="mb-0 pa-0"></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed color="primary" small @click="onSubmitFor">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
    <loading :active="loader" :opacity="0.9" color="#ff6b00" />
  </section>
</template>

<script>
import alerts from "@/mixins/alerts";
import Loading from "vue-loading-overlay";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import setupService from "@/services/SetupService/setupService";
import commonService from "@/services/CommonService/commonService.js";
import partnerService from "@/services/partnerService/partnerService.js";
import { validations, BranchUserSetup } from "@/utils/validation";
import { nodotNumber } from "@/utils/validate.js";

export default {
  name: "User Setup",
  mixins: [alerts],
  data() {
    return {
      ...validations,
      ...BranchUserSetup,
      nodotNumber,
      loader: false,
      IsIntegrated: false,
      is_disable: false,
      valid: true,
      partner_code: null,
      agentType: [
        { text: "Bank & Finance", value: "1" },
        { text: "Private Agent", value: "2" },
      ],
      alt_MobileValidations: [],
      userTitle: [],
      userDetails: {
        first_name: "",
        middle_name: "",
        last_name: "",
        user_name: "",
        title: "",
        gender: "",
        partner_code: "",
        timezone: "",
        agent_type: "1",
        login_type: "Single",
        address: "",
        country: "",
        mobile: "",
        alt_mobile: "",
        email: "",
        pay_transaction_from: null,
        pay_transaction_to: null,
        send_transaction_from: null,
        send_transaction_to: null,
        max_report_view_days: null,
        password_change_warning_days: null,
        password_change_days: null,
        user_type: "PRT",
        session_timeout: null,
      },
      ApiUser: {
        partner_id: this.$route.query.partner_id,
        branch_id: this.$route.query.branch_id,
        user_id: 0,
        api_user_id: "",
        api_access_code: "",
        api_authentication_code: "",
        api_receiving_code: "",
        callback_url: "",
      },
      countryOptions: [],
      timeZones: [],
    };
  },
  components: {
    Loading,
    BreadCrumb,
  },
  mounted() {
    this.getcountryList();
    this.gettimeZone();
    this.getdropdowntypes("UTC");
    this.partner_code = this.$route.query.partner_code;
    this.userDetails.partner_code = this.partner_code;
    console.log(this.userDetails.partner_code);
    // const item = this.$route.query.partner_code;
    if (this.$route.query.id) {
      //   console.log(item, "EDIT");
      // this.getApiuserInfo(this.$route.query.id);
      this.getPartnerUserById(this.$route.query.id);
      this.partner_code = this.$route.query.partner_code;
      this.userDetails.user_type = "PRT";
    }
  },
  methods: {
    // allowIntegration(value) {
    //   this.is_disable = value;
    // },
    validateAltNumber(val) {
      if (val) {
        if (val && val.length <= 8) {
          this.alt_MobileValidations.push(
            "Mobile Number must be more than 8 Numbers"
          );
        } else if (val && val.length > 12) {
          this.alt_MobileValidations.push(
            "Mobile Number must be less than 12 Numbers"
          );
        } else {
          this.alt_MobileValidations = [];
        }
      } else {
        this.alt_MobileValidations = [];
      }
    },
    onSubmitFor() {
      if (this.userDetails.login_id) {
        this.updatePartnerUserData(this.userDetails.login_id);
        console.log("update");
      } else {
        this.savePartnerUserData();
        console.log("Save");
      }
    },
    async getPartnerUserById(id) {
      try {
        const response = await partnerService.getPartnerUsers(id);
        if (response.data.status_code == 200) {
          this.userDetails = response.data.data[0];
          this.IsIntegrated = response.data.data[0].is_allow_integration;
          this.ApiUser = response.data.data[0];
        } else {
          this.showAlertError("Failed" + response.data.message);
        }
      } catch (e) {
        console.log(e);
        this.showAlertError("fetched data Failed: Something went wrong");
      }
    },
    async generateInetgrationData() {
      try {
        const response = await partnerService.generateInetgrationData({
          partner_code: this.partner_code,
        });
        if (response.data.status_code == 200) {
          console.log(response.data.data[0]);
          this.ApiUser.api_access_code = response.data.data[0].api_access_code;
          this.ApiUser.api_user_id = response.data.data[0].api_user_id;
          this.ApiUser.api_authentication_code =
            response.data.data[0].api_authentication_code;
        } else {
          this.showAlertError("Failed" + response.data.message);
        }
      } catch (e) {
        console.log(e);
        this.showAlertError("fetched data Failed: Something went wrong");
      }
    },
    async savePartnerUserData() {
      const validate = this.$refs.form.validate();
      if (validate) {
        try {
          const response = await partnerService.addPartnerUser(
            this.userDetails
          );
          console.log("response", response);
          if (response.data.status_code == 200) {
            this.showAlertSuccess(response.data.message);
            if (this.IsIntegrated) {
              this.ApiUser.user_id = response.data.data[0].id;
              console.log(this.ApiUser);
              this.addApiUser(this.ApiUser);
            }
          } else {
            this.showAlertError(`Save User: ${response.data.message}`);
          }
        } catch (e) {
          console.log("error branch", e);
          console.log(e);
          this.showAlertError("Saved Data Failed : Something went wrong");
        }
      }
    },
    async updatePartnerUserData(id) {
      const validate = this.$refs.form.validate();
      this.userDetails.user_type = "PRT";
      if (validate) {
        try {
          const response = await partnerService.updatePartnerUser(
            id,
            this.userDetails
          );
          4;
          console.log(this.userDetails.id);
          if (response.data.status_code == 200) {
            this.showAlertSuccess(response.data.message);
            if (this.IsIntegrated) {
              this.ApiUser.user_id = response.data.data[0].id;
              console.log(this.ApiUser.user_id);
              this.updateApiUser();
            }
          } else {
            this.showAlertError("Failed" + response.data.message);
          }
        } catch (e) {
          console.log(e);
          this.showAlertError("Update Data Failed : Something went wrong");
        }
      }
    },
    // saveUserData() {
    //     const validate = this.$refs.form.validate();
    //     if(validate){
    //         console.log(this.userDetails)
    //     }
    // },
    async getcountryList() {
      try {
        const response = await setupService.getCountrysetupList();
        if (response.status === 200) {
          this.countryOptions = response.data.data.map((i) => {
            return { text: i.name, value: i.iso_alpha3 };
          });
        }
        console.log("countrys", response);
      } catch (e) {
        console.error(e);
        this.countryOptions = [];
      }
    },
    async gettimeZone() {
      try {
        const response = await commonService.gettimeZone();
        if (response.data.status_code === 200) {
          this.timeZones = response.data.data;
        }
        //  else if (response.data.status_code === 401) {
        //     this.returnNewToken();
        //     this.gettimeZone();
        // }
      } catch (error) {
        console.error("Error fetching :", error);
      }
    },
    async getdropdowntypes(code) {
      try {
        const response = await commonService.getparameterdropdowns(code);
        if (response.data.status_code === 200) {
          console.log("UTC codes", response.data.data);
          this.userTitle = response.data.data.map((i) => {
            return { text: i.value, value: i.value_code };
          });
        }
        // else if (response.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getdropdowntypes();
        // }
      } catch (error) {
        console.error("Error fetching :", error);
      }
    },

    //------------------------------partner API INFO ---------------------------------//

    async addApiUser(data) {
      const validate = this.$refs.form.validate();
      if (validate) {
        try {
          const response = await partnerService.addApiuserInfo(data);
          if (response.data.status_code == 200) {
            this.showAlertSuccess(response.data.message);
            setTimeout(() => {
              this.$router.push({
                name: "User Summary",
                query: {
                  partner_code: this.userDetails.partner_code,
                  partner_id: this.ApiUser.partner_id,
                  branch_id: this.ApiUser.branch_id,
                },
              });
            }, 300);
            console.log("response", response);
          } else {
            this.showAlertError(`Save User: ${response.data.message}`);
          }
        } catch (e) {
          console.log(e);
          this.showAlertError("Saved Data Failed : Something went wrong");
        }
      }
    },

    async getApiuserInfo(id) {
      try {
        const response = await partnerService.getApiuserInfo(id);
        if (response.data.status_code == 200) {
          this.ApiUser = response.data.data[0];
          console.log("response", response);
        } else {
          // this.showAlertError(`Save User: ${response.data.message}`);
        }
      } catch (e) {
        console.log(e);
        this.showAlertError("Saved Data Failed : Something went wrong");
      }
    },
    async updateApiUser() {
      const validate = this.$refs.form.validate();
      if (validate) {
        try {
          const response = await partnerService.updateApiuserInfo(
            this.ApiUser.id,
            this.ApiUser
          );
          if (response.data.status_code == 200) {
            this.showAlertSuccess(response.data.message);
            setTimeout(() => {
              this.$router.push({
                name: "User Summary",
                query: {
                  partner_code: this.userDetails.partner_code,
                  partner_id: this.ApiUser.partner_id,
                  branch_id: this.ApiUser.branch_id,
                },
              });
            }, 300);
            console.log("response", response);
          } else {
            this.showAlertError(`${response.data.message}`);
          }
        } catch (e) {
          console.log(e);
          this.showAlertError("Saved Data Failed : Something went wrong");
        }
      }
    },
  },
};
</script>

<style>
.required:after {
  content: " *";
  color: red;
}

.v-sheet--offset {
  top: -14px;
  width: 200px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}

.v-sheet--offset1 {
  top: -20px;
  position: relative;
  border-radius: 10px;
  background-color: rgb(131, 24, 24) !important;
}

.outlined {
  border-radius: 7px;
  border: 1px solid gray;
}

.v-radio.v-label {
  margin-bottom: 0px !important;
}

.v-input--selection-controls .v-radio > .v-label {
  margin: auto !important;
}

.v-input--selection-controls__input + .v-label {
  margin: auto !important;
}
</style>
